import $api from "@/core/services/ApiService";
import { AxiosRequestConfig } from "axios";

class ActivityLogEndpoint {
  public list(params: AxiosRequestConfig = {}) {
    return $api.get("a/activities", params);
  }
  public report(params: AxiosRequestConfig = {}) {
    return $api.get("a/activities/report", params);
  }
}

export default ActivityLogEndpoint;
